import config from 'config';

const LOAD = 'greyhound-racing/meeting/LOAD';
const LOAD_SUCCESS = 'greyhound-racing/meeting/LOAD_SUCCESS';
const LOAD_FAIL = 'greyhound-racing/meeting/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        meeting: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isMeetingLoading(globalState, meetingId) {
  return globalState.greyhoundRacing.meeting
      && globalState.greyhoundRacing.meeting.loading
      && globalState.greyhoundRacing.meeting.meeting
      && globalState.greyhoundRacing.meeting.meeting.id === meetingId;
}

export function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.greyhoundRacing.loadMeeting}/${id}`)
  };
}

// given a race ID load the corresponding meeting for this race
export function loadMeetingByRaceId(raceId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.greyhoundRacing.loadMeeting}`, {
      params:{
        raceId
      }
    })
  };
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/reducers/meeting.js